module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_SKmagic_m.1d0727953b87b3b8e0f4ea1637535fe5.png";